import { useLocation, matchPath } from 'react-router-dom'

// ----------------------------------------------------------------------

export default function useActiveLink(path, deep = true) {
  const { pathname, hash } = useLocation()

  const [pathWithoutHash, pathHash] = (path || '').split('#')

  const normalActive = pathWithoutHash
    ? !!matchPath({ path: pathWithoutHash, end: true }, pathname)
    : false

  const deepActive = pathWithoutHash
    ? !!matchPath({ path: pathWithoutHash, end: false }, pathname)
    : false

  const hashActive = pathHash ? hash === `#${pathHash}` : true

  return {
    active: (deep ? deepActive : normalActive) && hashActive,
    isExternalLink: (path || '').includes('http'),
  }
}
